<template>
  <div class="parklist">
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for="a_name">停车道路：</label>
            <input
              v-model.trim="search.parkName"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <span class="add_btn">
              <button
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addrOrEdit()"
              >
                添加
              </button>
            </span>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车场名称"
            prop="parkingName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车场编号"
            prop="attr1"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车场ID"
            prop="parkingId"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="类型"
            prop="parkingType"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="总车位数"
            prop="totalNum"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="剩余车位数"
            prop="leftNum"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="上报城市大脑">
            <template slot-scope="scope">
              {{ scope.row.pushFlag == "y" ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="创建时间"
            prop="crtTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="地址"
            prop="parkingAddress"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="支付方式"
            prop="payTypeName"
          >
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="500px">
            <template slot-scope="scope">
              <template
                v-if="
                  scope.row.parkingType == '路侧' ||
                  scope.row.parkingType == 'roadside'
                "
              >
                <button
                  class="code-download operate-button"
                  @click="
                    getChargeRule(scope.row.parkingId, scope.row.chargeRuleId)
                  "
                >
                  收费规则
                </button>
              </template>
              <button
                class="edit operate-button"
                type="button"
                @click="addrOrEdit(scope.row.parkingId)"
              >
                修改
              </button>

              <button
                class="delete operate-button"
                @click="delPark(scope.row.parkingId)"
                type="button"
              >
                删除
              </button>
              <button
                class="code-download operate-button"
                @click="payBind(scope.row.parkingId, scope.row.paymentChannel)"
                type="button"
              >
                支付绑定
              </button>
              <template
                v-if="
                  scope.row.parkingType == '室内' ||
                  scope.row.parkingType == 'onsite'
                "
              >
                <button
                  class="code-download operate-button"
                  @click="generateActivationCode(scope.row.parkingId)"
                  type="button"
                >
                  生成激活码
                </button>
                <button
                  class="code-download operate-button"
                  @click="viewActivationCode(scope.row.parkingId)"
                  type="button"
                >
                  查看激活码
                </button>
                <button
                  class="code-download operate-button"
                  @click="
                    codeDownload(scope.row.parkingId, scope.row.parkingName)
                  "
                  type="button"
                >
                  二维码
                </button>
              </template>
              <!-- <button
                class="delete operate-button"
                type="button"
                @click="configure(scope.row.parkingId)"
              >
                配置
              </button> -->
              <!-- <button
                class="code-download operate-button"
                @click="chargeLower"
                type="button"
              >
                计费规则下发
              </button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>

    <!-- 添加停车场 -->
    <el-dialog
      :close-on-click-modal="false"
      :lock-scroll="false"
      title="添加停车道路/修改"
      :visible.sync="dialogFormVisible"
      width="1200px"
      @close="closeDialogParking"
      class="dialog-park-form"
    >
      <el-form
        class="fl parking-form"
        style="width: 35%"
        ref="form"
        label-position="right"
        :model="form"
        :rules="rules"
        :label-width="formLabelWidth"
        id="form"
      >
        <el-form-item label="城市" prop="city">
          <el-col :span="18">
            <el-select
              @change="changeCity"
              filterable
              v-model.trim="form.city"
              placeholder="请选择"
            >
              <el-option
                v-for="item in allCity"
                :key="item.value"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-if="showCounty" label="县/区" prop="county">
          <el-col :span="18">
            <el-select
              @change="changeCounty"
              filterable
              v-model.trim="form.county"
              placeholder="请选择"
            >
              <el-option
                v-for="item in allCounty"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="物业" prop="propertyId">
          <el-col :span="18">
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="form.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="道路名称" prop="name">
          <el-col :span="18">
            <el-input v-model="form.name">
              <!-- <template slot="append">道路</template> -->
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="道路编号" prop="attr1">
          <el-col :span="18">
            <el-input v-model="form.attr1">
              <!-- <template slot="append">道路</template> -->
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-col :span="18">
            <el-input
              readonly
              type="textarea"
              v-model="form.address"
              auto-complete="off"
              disabled
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="类型">
          <el-col :span="18">
            <el-select v-model="form.type" placeholder="请选择">
              <el-option
                v-for="item in allType"
                :key="item.index"
                :label="item.labelZhCh"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item label="总车位">
          <el-col :span="18">
            <el-input v-model="form.totalNum"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="城市大脑车场编号">
          <el-col :span="18">
            <el-input v-model="form.attr8"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-col :span="18">
            <el-checkbox v-model="form.pushFlag" true-label="y" false-label="n"
              >数据上报城市大脑</el-checkbox
            >
          </el-col>
        </el-form-item>
      </el-form>
      <div class="fr" style="width: 65%; height: 500px; position: relative">
        <div
          style="
          
            z-index: 100;
            background: white;
            width: 100%;
            height: 50px;
          "
        >
          <el-input placeholder="请输入内容" v-model="form.address">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="onAddressToLatlng"
              :disabled="!this.form.address"
            ></el-button>
          </el-input>
        </div>
        <div id="areaMap" style="width: 100%; height: 100%"></div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addrOrEditTrue">确 定</el-button>
        <el-button @click="onParkCancleBtn">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 设置收费规则-->
    <el-dialog
      :close-on-click-modal="false"
      :lock-scroll="false"
      title="收费规则"
      :visible.sync="dialogFormVisibleRule"
      :width="chargeRuldeMode === '1' ? '1000px' : '1350px'"
      @open="openDialogRule"
      @close="closeDialogRule"
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
        >
          <el-form-item label="收费模式:" prop class="chargerule-mode">
            <el-col :span="18">
              <template>
                <el-select
                  filterable
                  v-model="chargeRuldeMode"
                  placeholder="请选择"
                  @change="getChargeRuleMode"
                >
                  <el-option
                    v-for="item in allChargeRuleTypeData"
                    :key="item.value"
                    :label="item.labelDefault"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </template>
            </el-col>
          </el-form-item>
          <!--按小时收费-->
          <template v-if="showTimeAdd">
            <div class="columns">
              <el-form-item label="免费停车时长：" prop="freeParking">
                <el-input v-model="ruleForm.freeParking"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <!-- <el-form-item label="最高限额：" prop="ceiling">
                <el-input v-model="ruleForm.ceiling"></el-input>
                <p class="position">元</p>
              </el-form-item> -->
            </div>
            <el-form-item label="起始时间" prop="beginTime">
              <el-time-picker
                v-model="ruleForm.beginTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="起始时间"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="end">
              <el-time-picker
                v-model="ruleForm.end"
                value-format="HH:mm"
                :picker-options="{ minTime: 'ruleForm.beginTime' }"
                format="HH:mm"
                placeholder="结束时间"
              ></el-time-picker>
            </el-form-item>
            <div class="columns limit">
              <el-form-item class="limit-tip" label="最高限额:"> </el-form-item>
              <el-form-item label="小车">
                <el-input v-model="ruleForm.ceiling"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="大车">
                <el-input v-model="ruleForm.attr5"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="超大车">
                <el-input v-model="ruleForm.attr6"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns">
              <el-form-item label="首段时长:">
                <el-input v-model="ruleForm.money1"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <el-form-item label="(小车)收费">
                <el-input v-model="ruleForm.money2"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(大车)收费">
                <el-input v-model="ruleForm.attr1"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(超大车)收费">
                <el-input v-model="ruleForm.attr3"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns">
              <el-form-item label="超首段时长后每">
                <el-input v-model="ruleForm.money3"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <el-form-item label="(小车)收费">
                <el-input v-model="ruleForm.money4"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(大车)收费">
                <el-input v-model="ruleForm.attr2"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(超大车)收费">
                <el-input v-model="ruleForm.attr4"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
          </template>
          <!--按时段收费-->
          <template v-if="showPeriod">
            <div class="columns">
              <el-form-item label="免费停车时长：" prop="freeParking">
                <el-input v-model="periodRule.freeParking"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <el-form-item label="最高限额：" prop="ceiling">
                <el-input v-model="periodRule.ceiling"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <el-form-item label="起始时间" prop="beginTime">
              <el-time-picker
                v-model="periodRule.beginTime"
                format="HH:mm"
                value-format="HH:mm"
                placeholder="起始时间"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="end">
              <el-time-picker
                v-model="periodRule.end"
                value-format="HH:mm"
                :picker-options="{ minTime: 'periodRule.beginTime' }"
                format="HH:mm"
                placeholder="结束时间"
              ></el-time-picker>
            </el-form-item>

            <div class="columns">
              <el-form-item label="首段时长:">
                <el-input v-model="periodRule.money1"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <el-form-item label="(小车)收费">
                <el-input v-model="periodRule.money2"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(大车)收费">
                <el-input v-model="periodRule.attr1"></el-input>
                <p class="position">元</p>
              </el-form-item>
              <el-form-item label="(超大车)收费">
                <el-input v-model="periodRule.attr3"></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>

            <div class="period-group">
              <div
                class="columns"
                v-for="period in periodRule.periods"
                :key="period.id"
              >
                <el-form-item label="超过:">
                  <el-input v-model="period.exceed"></el-input>
                  <p class="position">分钟</p>
                </el-form-item>
                <el-form-item label="每">
                  <el-input v-model="period.every"></el-input>
                  <p class="position">分钟</p>
                </el-form-item>
                <el-form-item label="(小车)收费">
                  <el-input v-model="period.car"></el-input>
                  <p class="position">元</p>
                </el-form-item>
                <el-form-item label="(大车)收费">
                  <el-input v-model="period.cart"></el-input>
                  <p class="position">元</p>
                </el-form-item>
                <el-form-item label="(超大车)收费">
                  <el-input v-model="period.superCar"></el-input>
                  <p class="position">元</p>
                </el-form-item>
                <div class="reduce" v-if="periodRule.periods.length > 1">
                  <i
                    class="el-icon-remove-outline"
                    @click="onRuleReduceClick(period.id)"
                  ></i>
                </div>
              </div>
            </div>
            <div class="add">
              <i
                class="el-icon-circle-plus-outline"
                @click="onRuleAddClick"
              ></i>
            </div>
          </template>
          <!--按工作日/非工作日计费-->
          <template v-if="showTimeQuantum">
            <div class="size">
              <span>工作日收费：</span>
            </div>
            <div class="columns columns-others">
              <el-form-item label="免费停车时长：" prop="freeParking">
                <el-input v-model="formRuleOne.freeTime"></el-input>
                <p class="position">分钟</p>
              </el-form-item>
              <!-- <el-form-item label="最高限额：" prop="ceiling">
                <el-input v-model="formRuleOne.params[0].wdLastPrice"></el-input>元
              </el-form-item>-->
            </div>
            <!-- <el-form-item label="起止时间：" prop="startingAndEndF"> -->
            <!-- <el-time-select
                placeholder="起始时间"
                v-model="formRuleOne.params[0].wdStartOrEndTime[0]"
                :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00'
              }"
              ></el-time-select>
              <el-time-select
                placeholder="结束时间"
                v-model="formRuleOne.params[0].wdStartOrEndTime[1]"
                :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00',
              }"
            ></el-time-select>-->
            <el-form-item label="起止时间：" prop="wdStartOrEndTime">
              <el-time-picker
                format="HH:mm"
                value-format="HH:mm"
                v-model="ruleForm.wdStartOrEndTime"
                placeholder="起始时间"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="起止时间：" prop="wdStartOrEndTimeEnd">
              <el-time-picker
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{ minTime: 'ruleForm.wdStartOrEndTime' }"
                v-model="ruleForm.wdStartOrEndTimeEnd"
                placeholder="结束时间"
              ></el-time-picker>
            </el-form-item>
            <div class="columns">
              <el-form-item label="首段时长:">
                <el-input
                  v-model="formRuleOne.params[0].wdAfterHourF"
                ></el-input>
                <p class="position">小时</p>
              </el-form-item>
              <el-form-item label="收费">
                <el-input
                  v-model="formRuleOne.params[0].wdFirstPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns column-last">
              <!-- <el-form-item label="超首段时长后每">
                  <el-input v-model="ruleForm.money3" ></el-input>分钟
                </el-form-item>
              <el-form-item label="收费">
                  <el-input v-model="ruleForm.money4" ></el-input>元
              </el-form-item>-->
              <el-form-item>
                <el-input
                  readonly
                  v-model="formRuleOne.params[0].wdAfterHourF"
                ></el-input
                >-
                <el-input v-model="formRuleOne.params[0].wdLastHour"></el-input>
                <p class="position">小时</p>
              </el-form-item>
              <el-form-item label="收费">
                <el-input
                  v-model="formRuleOne.params[0].wdAfterPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns">
              <el-form-item label>
                <el-input
                  readonly
                  v-model="formRuleOne.params[0].wdLastHour"
                ></el-input>
                <p class="position">小时后,</p>
              </el-form-item>
              <el-form-item label="收费">
                <el-input
                  v-model="formRuleOne.params[0].wdLastPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="size">
              <span>非工作日收费：</span>
            </div>
            <div class="columns columns-others">
              <el-form-item label="免费停车时长：" prop="freeParkingF">
                <el-input v-model="formRuleOne.freeTime"></el-input>
                <p class="position">分钟</p>
              </el-form-item>

              <!-- <el-form-item label="最高限额：" prop="ceilingF">
                <el-input v-model="formRuleOne.params[0].odLastPrice"></el-input>元
              </el-form-item>-->
            </div>

            <!-- <el-form-item label="起止时间：" prop="startingAndEndF"> -->
            <!-- <el-time-select
                placeholder="起始时间"
                v-model="formRuleOne.params[0].odStartOrEndTime[0]"
                :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00'
              }"
              ></el-time-select>
              <el-time-select
                placeholder="结束时间"
                v-model="formRuleOne.params[0].odStartOrEndTime[1]"
                :picker-options="{
                start: '00:00',
                step: '00:01',
                end: '24:00',
                minTime:ruleForm.beginTimeF
              }"
            ></el-time-select>-->
            <el-form-item label="起止时间：" prop="odStartOrEndTime">
              <el-time-picker
                format="HH:mm"
                value-format="HH:mm"
                v-model="ruleForm.odStartOrEndTime"
                placeholder="起始时间"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="起止时间：" prop="odStartOrEndTimeEnd">
              <el-time-picker
                format="HH:mm"
                value-format="HH:mm"
                :picker-options="{ minTime: 'ruleForm.odStartOrEndTime' }"
                v-model="ruleForm.odStartOrEndTimeEnd"
                placeholder="结束时间"
              ></el-time-picker>
            </el-form-item>
            <div class="columns">
              <el-form-item label="首段时长：" prop="firstTime">
                <el-input
                  v-model="formRuleOne.params[0].odAfterHourF"
                ></el-input>
                <p class="position">小时</p>
              </el-form-item>
              <el-form-item label="收费" prop="firstTime">
                <el-input
                  v-model="formRuleOne.params[0].odFirstPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns column-last">
              <!-- <el-form-item label="超首段时长后每">
                  <el-input v-model="ruleForm.moneyF3" ></el-input>分钟
                </el-form-item>
              <el-form-item label="收费">
                  <el-input v-model="ruleForm.moneyF4" ></el-input>元
              </el-form-item>-->
              <el-form-item>
                <el-input
                  readonly
                  v-model="formRuleOne.params[0].odAfterHourF"
                ></el-input
                >-
                <el-input v-model="formRuleOne.params[0].odLastHour"></el-input>
                <p class="position">小时</p>
              </el-form-item>
              <el-form-item label="收费">
                <el-input
                  v-model="formRuleOne.params[0].odAfterPrice"
                ></el-input>
                <p class="position">元</p>
              </el-form-item>
            </div>
            <div class="columns">
              <el-form-item label>
                <el-input
                  readonly
                  v-model="formRuleOne.params[0].odLastHour"
                ></el-input>
                <p class="position">小时后,</p>
              </el-form-item>
              <el-form-item label="收费" prop="firstTime">
                <el-input v-model="formRuleOne.params[0].odLastPrice"></el-input
                >元
              </el-form-item>
            </div>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addrOrEditRuleTrue">确 定</el-button>
        <el-button @click="dialogFormVisibleRule = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 选择巡检员 -->
    <el-dialog
      title="选择巡检员"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="outerCodeDialogVisible"
    >
      <el-radio-group
        v-model="codeDownloadData.chargeUserId"
        @change="selectedChargerUser"
      >
        <el-radio
          v-for="item in allChargeUserData"
          :label="item.id"
          :key="item.id"
          >{{ item.username }}</el-radio
        >
      </el-radio-group>
    </el-dialog>
    <!--下载二维码-->
    <el-dialog
      title="下载二维码"
      :close-on-click-modal="false"
      :visible.sync="codeDialogVisible"
      :lock-scroll="false"
    >
      <table class="table">
        <thead>
          <tr>
            <td>二维码边长(cm)</td>
            <td>建议扫描距离(米)</td>
            <td>下载链接</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>8cm</td>
            <td>0.5m</td>
            <td @click="downloadQrcode(258, 258)">
              <button class="code-download">下载</button>
            </td>
          </tr>
          <tr>
            <td>15cm</td>
            <td>1m</td>
            <td @click="downloadQrcode(430, 430)">
              <button class="code-download">下载</button>
            </td>
          </tr>
        </tbody>
      </table>
      <div id="qrcode"></div>
    </el-dialog>

    <!--支付绑定-->
    <el-dialog
      title="绑定支付方式"
      :visible.sync="payTypeDialogVisible"
      width="30%"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-radio-group v-model="payTypeForm.payType" @change="hasPayConfigure">
        <el-radio
          v-for="item in allPayTypeData"
          :label="item.value"
          :key="item.id"
          >{{ item.labelDefault }}</el-radio
        >
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="payBindTrue">确 定</el-button>
        <el-button @click="payTypeDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--激活码-->
    <el-dialog
      title="激活码"
      :visible.sync="activationCodeDialogVisible"
      width="30%"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-form
        class="fl"
        ref="form"
        label-position="right"
        :model="activationCodeForm"
        :label-width="formLabelWidth"
        id="form"
      >
        <el-form-item label="设备标识" prop>
          <el-col :span="18">
            <el-input v-model="activationCodeForm.udId"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="类型" prop>
          <el-col :span="18">
            <el-select
              filterable
              v-model="activationCodeForm.type"
              placeholder="请选择"
              @change="getActivationCodeType"
            >
              <el-option
                v-for="item in allActivationType"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item v-show="dateView" label="开始时间" prop>
          <el-col :span="18">
            <el-date-picker
              v-model="activationCodeForm.begindate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item v-show="dateView" label="结束时间" prop>
          <el-col :span="18">
            <el-date-picker
              v-model="activationCodeForm.enddate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="generateActivationCodeTrue"
          >确 定</el-button
        >
        <el-button @click="activationCodeDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!--激活码列表-->
    <el-dialog
      title="激活码列表"
      :visible.sync="viewActivationCodeDialogVisible"
      width="80%"
      :lock-scroll="false"
      @open="viewActivationCodeList"
    >
      <el-table border :data="activationCodeData">
        <el-table-column show-overflow-tooltip label="停车场">
          <template slot-scope="scope">{{
            scope.row.parkingId ? JSON.parse(scope.row.parkingId).name : ""
          }}</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="设备标识符"
          prop="udId"
        ></el-table-column>
        <el-table-column show-overflow-tooltip label="类型">
          <template slot-scope="scope">{{
            scope.row.type == 1 ? "永久" : "起止时间"
          }}</template>
        </el-table-column>

        <el-table-column
          show-overflow-tooltip
          label="激活码"
          prop="activationCode"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="开始时间"
          prop="begindate"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="结束时间"
          prop="enddate"
        ></el-table-column>
      </el-table>
    </el-dialog>

    <!--配置 -->
    <el-dialog
      :lock-scroll="false"
      :close-on-click-modal="false"
      title="配置"
      :visible.sync="dialogConfigureVisible"
      width="500px"
      @open="openConfigureDialog"
      @close="closeConfigureDialog"
    >
      <ul>
        <li v-for="item in configureData" :key="item.id">
          <span class="configure-message">{{ item.labelDefault }}(单选)：</span>
          <span
            class="configure-message"
            @click="clickItemConfigure(item, 'open')"
          >
            启用
            <template>
              <img
                v-if="item.isOpen"
                width="10px"
                src="@/assets/images/click.png"
              />
              <img v-else width="10px" src="@/assets/images/unclick.png" />
            </template>
          </span>
          <span
            class="configure-message"
            @click="clickItemConfigure(item, 'close')"
          >
            关闭
            <template>
              <img
                v-if="item.isClose"
                width="10px"
                src="@/assets/images/click.png"
              />
              <img v-else width="10px" src="@/assets/images/unclick.png" />
            </template>
          </span>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="configureOneConfigure"
          >确 定</el-button
        >
        <el-button @click="dialogConfigureVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  chargeUserList,
  addOrEdit,
  getAllPayType,
  getActivationCodeList,
  getPayConfigure,
  getParkingType,
  refreshToken,
  getAllParkingsByEnabled,
  getParkSingle,
  getChargeRuleF,
  parkingBusType,
  dictValue,
  getCity,
  parkList,
  getRulesType,
  addOrUpdateChargeRule,
  getChargeRule,
  parkAddTow,
  parkAdd,
  addMapOverlay,
  addMapOverlayl,
  setMapEvent,
  addMapControl,
  getManagerList,
  getAllCounty,
  requestAllChargeRuleType,
  addOrUpdateChargeRuleByTimeQuantum,
  getChargeRuleByTimeQuantum,
  requestParkingBaseConfig,
  getOneParkingConfigure,
  requestConfigureOneParkingConfigure,
  getGenerateActivationCode,
  fetchPropertyList,
} from "@/api/url";

import Page from "../../commons/page.vue";

import Refresh from "../../commons/refresh.vue";

import AllTree from "../../commons/allTree.vue";

import Cookies from "js-cookie";

import QRCode from "qrcodejs2"; // 引入qrcode

export default {
  name: "park",
  data() {
    return {
      searchAddress: "",
      // invoiceChecked: "",
      propertyList: [],
      configureForm: {
        parkingId: "",
        code: [],
      },
      baseConfigureData: [],
      configureData: [], //用户配置数据
      menuKey: 1,
      dialogConfigureVisible: false, //配置
      isOpen: false, //配置
      isClose: false, //配置
      parklist_btn_add: false,
      parklist_btn_rule: false,
      parklist_btn_pkset: false,
      parklist_btn_control: false,
      parklist_btn_person: false,
      parkset_btn_edit: false,
      parklist_btn_remove: false,
      codeDialogVisible: false,
      activationCodeDialogVisible: false,
      viewActivationCodeDialogVisible: false,
      showTimeQuantum: false,
      showTimeAdd: true,
      showPeriod: false,
      dateView: false,
      payTypeDialogVisible: false,
      allPayTypeData: [],
      allChargeRuleTypeData: [],
      allChargeUserData: [],
      outerCodeDialogVisible: false,
      showCounty: false,
      codeDownloadData: {
        parkingId: "",
        parkingName: "",
        chargeUserId: "",
      },
      activationCodeForm: {
        parkingId: "",
        udId: "",
        type: "",
        begindate: "",
        enddate: "",
      },
      activationCodeData: [],
      allActivationType: [
        { name: "永久", value: 1 },
        { name: "起止时间", value: 2 },
      ],
      payTypeForm: {
        payType: "",
        parkingId: "",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      treeData: {
        parentId: "",
      },

      moduleName: "parking",
      form: {
        id: "",
        name: "",
        type: "roadside",
        city: "",
        scenImgUrl: "",
        address: "",
        longitude: "",
        latitude: "",
        manager: "",
        parkingBusType: "",
        county: "",
        propertyId: null,
        attr1: "",
        pushFlag: "n",
        totalNum: 0,
        attr8:""//城市大脑车场编号
      },
      enabledFlag: "n",
      search: {
        pageNumber: 1,
        pageSize: 10,
        parkName: null,
        propertyId: null,
      },
      chargeRuldeMode: "4",
      //按时累加
      ruleForm: {
        chargeId: "",
        parkingId: "",
        chargeRuleId: "",
        freeParking: "",
        ceiling: "",
        startingAndEnd: "",
        beginTime: "",
        end: "",
        money1: "",
        money2: "",
        money3: "",
        money4: "",
        freeParkingF: "",
        ceilingF: "",
        startingAndEndF: "",
        beginTimeF: "",
        endF: "",
        moneyF1: "",
        moneyF2: "",
        moneyF3: "",
        moneyF4: "",
        attr1: "",
        attr2: "",
        attr3: "",
        attr4: "",
        attr5: "",
        attr6: "",
        wdStartOrEndTime: "",
        wdStartOrEndTimeEnd: "",
        odStartOrEndTime: "",
        odStartOrEndTimeEnd: "",
      },
      //按工作日/非工作日收费
      //室外1
      formRuleOne: {
        chargeRuleId: "",
        parkingId: "",
        freeTime: "",
        params: [
          {
            lrId: "",
            carType: "auto",
            // wdStartOrEndTime: ["", ""],
            wdAfterHourF: "",
            wdLastHour: "",
            wdFirstPrice: "",
            wdAfterPrice: "",
            wdLastPrice: "",
            wdFreeMin: "",
            // odStartOrEndTime: ["", ""],
            odAfterHourF: "",
            odLastHour: "",
            odFirstPrice: "",
            odAfterPrice: "",
            odLastPrice: "",
            odFreeMin: "",
          },
        ],
      },
      //按时段收费
      periodRule: {
        chargeId: "",
        parkingId: "",
        chargeRuleId: "",
        freeParking: "",
        ceiling: "",
        startingAndEnd: "",
        beginTime: "",
        end: "",
        money1: "",
        money2: "",
        money3: "",
        money4: "",
        attr1: "",
        attr2: "",
        attr3: "",
        attr4: "",
        periods: [
          {
            id: Math.random().toString(16).slice(2),
            exceed: "",
            every: "",
            car: "",
            cart: "",
            superCar: "",
          },
        ],
      },
      tableListData: {
        rows: [],
      },
      tableListDataExcel: {},
      tableListDataAll: {},
      downloadFileds: {
        停车场: "parkingName",
        类型: {
          field: "parkingType",
          callback: (value) => {
            return value == "roadside" ? "室外" : "室内";
          },
        },
        // '管理员':'username',
        创建时间: "crtTime",
        地址: "parkingAddress",
      },
      formLabelWidth: "150px",
      dialogFormVisible: false,
      allParkingBusType: [],
      allType: [
        {
          labelZhCh: "室内",
          value: "onsize",
        },
        {
          labelZhCh: "路侧",
          value: "roadside",
        },
      ],
      allCity: [],
      allCounty: [],
      allManager: [],
      allChargeRule: [],
      allChargeRuleSel: [
        {
          name: "室内",
          id: "3",
        },
        {
          name: "路侧",
          id: "1",
        },
      ],
      rules: {
        beginTime: [
          { required: true, message: "请输入起始时间", trigger: "blur" },
        ],
        end: [{ required: true, message: "请输入结束时间", trigger: "blur" }],
        beginTimeF: [
          { required: true, message: "请输入起始时间", trigger: "blur" },
        ],
        endF: [{ required: true, message: "请输入结束时间", trigger: "blur" }],
        wdStartOrEndTime: [
          { required: true, message: "请输入起始时间", trigger: "blur" },
        ],
        wdStartOrEndTimeEnd: [
          { required: true, message: "请输入结束时间", trigger: "blur" },
        ],

        odStartOrEndTime: [
          { required: true, message: "请输入起始时间", trigger: "blur" },
        ],
        odStartOrEndTimeEnd: [
          { required: true, message: "请输入结束时间", trigger: "blur" },
        ],
        city: [
          {
            required: true,
            message: "请选择城市",
            trigger: ["blur", "change"],
          },
        ],
        propertyId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          { required: true, message: "请填写车场名称", trigger: "blur" },
          // { min: 2, max: 8, message: "长度在 2 到 8 个字符", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请在地图上选取位置", trigger: "blur" },
        ],
      },
      map: {},
      currentMarker: null, // 当前地图上的标记点实例

      dialogFormVisibleRule: false,
      pageObj: {},
    };
  },
  filters: {
    handelParkingType(value) {
      let d = "";
      switch (value) {
        case "roadside":
          d = "路边";
          break;
        case "onsite":
          d = "室内";
          break;
        default:
          break;
      }
      return d;
    },
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    getAllProperty() {
      this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    changeCity: function (val) {
      this.form.county = "";
      let obj = {};
      obj = this.allCity.find((item) => {
        return item.id === val;
      });
      this.map.centerAndZoom(obj.name, 12);
      this.getCounty(val);
    },
    changeCounty(val) {
      let obj = {};
      obj = this.allCounty.find((item) => {
        return item.id === val;
      });
      this.map.centerAndZoom(obj.name, 12);
    },
    handleKeyup: function (e) {
      e.target.value = e.target.value.replace(
        /[ !`~\!@#\$%\^&\*()_+=\-\;\:\"\'\\/?,<>|\A-Za-z\u4e00-\u9fa5]+/g,
        ""
      );
    },
    handleAfterpaste: function (e) {
      e.target.value = e.target.value.replace(
        /[ !`~\!@#\$%\^&\*()_+=\-\;\:\"\'\\/?,<>|\A-Za-z\u4e00-\u9fa5]+/g,
        ""
      );
    },
    handleKeyupTime: function (e) {
      e.target.value = e.target.value.replace(/\D/g, "");
    },
    handleAfterpasteTime: function (e) {
      e.target.value = e.target.value.replace(/\D/g, "");
    },
    getParkType: function () {
      this.$get(dictValue() + "/parking_type").then((data) => {
        this.allType = data.data.rows;
      });
    },
    getParkingBusType: function () {
      this.$get(parkingBusType()).then((data) => {
        this.allParkingBusType = data;
      });
    },
    getCity: function () {
      this.$get(getCity(), {
        arealevel: "2",
        name: "",
        limit: "0",
      }).then((data) => {
        if (data.status != 200) return;
        this.allCity = data.data.rows;
      });
    },
    getCounty(val) {
      this.$get(getAllCounty(), {
        arealevel: "3",
        limit: "0",
        parentId: val,
      }).then((data) => {
        if (data.status != 200) {
          return _this.$layer.msg(data.message);
        }
        this.allCounty = data.data.rows;
      });
    },
    getRulesType: function () {
      this.$get(getRulesType()).then((data) => {
        // if(data.status!=200) return;
        this.allChargeRule = data;
      });
    },
    //下载所有车场的数据
    tableListAll: function () {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);

        this.tableListDataAll = data.data;
      });
    },
    tableList: function (curPage) {
      var _this = this;
      const { parkName, propertyId } = this.search;
      this.$get(parkList(), {
        parkingName: parkName ? parkName : null,
        parentId: propertyId ? propertyId : null,
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj = { ...pageObj };
        // _this.getPage(pageObj);

        const {
          data: { rows },
        } = data;
        _this.tableListData.rows = rows.map((item) => {
          if (item.parentId) {
            item.propertyName = JSON.parse(item.parentId).name;
          }
          item.payTypeName =
            this.allPayTypeData?.find(
              (type) => type.value === item?.paymentChannel
            )?.labelDefault ?? "";
          return item;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    searchList: function () {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.parkName = "";
    },

    toView: function (parkId, parkName) {
      this.storageScenId(parkId);
      this.$router.push({
        path: "/main/park/parkset",
        query: { id: parkId, name: parkName },
      });
    },
    toStaff: function (parkId, parkName) {
      this.storageScenId(parkId);
      this.$router.push({
        path: "/main/park/staff",
        query: { id: parkId, name: parkName },
      });
    },
    getPropertyId(id) {
      this.form.propretyId = id;
    },
    addrOrEdit: function (id) {
      this.dialogFormVisible = true;

      this.$nextTick(async () => {
        // 导入天地图工具类
        const {
          waitForTiandituAPI,
          createTiandituMap,
          setMapEvent,
          addMapControl,
          reverseGeocode,
          createMarker,
          addMarkerToMap,
          updateMarkerPosition
        } = await import('@/utils/tianditu');
        
        // 等待API加载
        await waitForTiandituAPI();
        
        // 创建地图
        this.map = createTiandituMap("areaMap", {
          centerLng: 111.26744121202825,
          centerLat: 31.883847150262206,
          zoom: 14
        });
        
        if (!this.map) {
          console.error('地图创建失败');
          return;
        }
        
        // 确保地图容器有尺寸
        const mapContainer = document.getElementById("areaMap");
        if (mapContainer) {
          console.log('地图容器尺寸:', mapContainer.offsetWidth, mapContainer.offsetHeight);
          // 如果容器没有尺寸，设置默认尺寸
          if (mapContainer.offsetWidth === 0 || mapContainer.offsetHeight === 0) {
            mapContainer.style.width = '100%';
            mapContainer.style.height = '100%';
            mapContainer.style.minHeight = '400px';
          }
        }
        
        // 延迟一下确保地图容器已渲染
        await new Promise(resolve => setTimeout(resolve, 200));
        
        // 天地图4.0在创建地图时已经自动加载图层，通常不需要手动添加
        // 如果地图不显示，可能是其他原因（API密钥、网络等）
        console.log('地图创建完成，检查地图状态');
        if (this.map) {
          console.log('地图对象:', this.map);
          // 检查地图容器
          const mapContainer = document.getElementById("areaMap");
          if (mapContainer) {
            console.log('地图容器尺寸:', mapContainer.offsetWidth, mapContainer.offsetHeight);
          }
        }
        
        setMapEvent(this.map);
        addMapControl(this.map);
        
        // 重置当前标记点
        this.currentMarker = null;
        
        // 确保导入的函数可用
        const {
          createMarker: createMarkerFn,
          addMarkerToMap: addMarkerToMapFn,
          updateMarkerPosition: updateMarkerPositionFn,
          reverseGeocode: reverseGeocodeFn
        } = await import('@/utils/tianditu');
        
        var _this = this;
        // 绑定地图点击事件
        this.map.addEventListener("click", function (e) {
          console.log('click map event:', e);
          // 根据坐标得到地址描述
          var point = e.lnglat || e.point;
          var lng = point ? (point.getLng ? point.getLng() : point.lng) : e.lng; // 经度 (longitude/lon)
          var lat = point ? (point.getLat ? point.getLat() : point.lat) : e.lat; // 纬度 (latitude/lat)
          
          console.log('地图点击位置 - 经度:', lng, '纬度:', lat);
          
          // 先存储经纬度到form（无论地址解析是否成功）
          // form.longitude 对应 lon（经度）
          // form.latitude 对应 lat（纬度）
          _this.form.longitude = lng; // lon -> form.longitude
          _this.form.latitude = lat;  // lat -> form.latitude
          
          // 如果已有标记点，更新位置；否则创建新标记点
          if (_this.currentMarker) {
            // 更新现有标记点位置
            console.log('更新现有marker位置');
            updateMarkerPositionFn(_this.currentMarker, lng, lat);
          } else {
            // 创建新标记点
            console.log('创建新marker');
            const marker = createMarkerFn(lng, lat);
            if (marker) {
              const added = addMarkerToMapFn(_this.map, marker);
              if (added) {
                _this.currentMarker = marker;
                console.log('Marker已添加到地图');
              } else {
                console.error('Marker添加失败');
              }
            } else {
              console.error('创建Marker失败');
            }
          }
          
          // 通过逆地理编码获取地址信息（必须通过 reverseGeocode 获取）
          reverseGeocodeFn(lng, lat, function (result) {
            console.log('reverse geocode result:', result);
            if (result) {
              if (result.address) {
                // 解析成功，存储地址到 form.address
                _this.form.address = result.address; // address -> form.address
                console.log('逆地理编码成功，地址:', result.address);
              } else {
                // 解析失败，但至少已保存经纬度
                console.warn('逆地理编码失败，无法获取地址，已保存经纬度:', lng, lat);
                // 如果地址为空，设置一个提示信息
                if (!_this.form.address) {
                  _this.form.address = `经度: ${lng}, 纬度: ${lat}`;
                }
              }
            } else {
              console.error('逆地理编码返回结果为空');
              // 如果地址为空，设置一个提示信息
              if (!_this.form.address) {
                _this.form.address = `经度: ${lng}, 纬度: ${lat}`;
              }
            }
          });
        });
      });

      if (Boolean(id)) {
        this.showCounty = false;
        this.$postRequest(getParkSingle(), { parkingId: id }).then(async (data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          this.form.id = data.data.parkingId;
          this.form.name = data.data.parkingName;
          this.form.type = data.data.parkingType;
          this.form.city = data.data.cityId;
          // 存储经纬度到form
          // form.longitude 对应 lon（经度）
          // form.latitude 对应 lat（纬度）
          this.form.latitude = data.data.pointLat;      // lat -> form.latitude
          this.form.longitude = data.data.pointLng;     // lon -> form.longitude
          this.form.manager = data.data.userId;
          this.form.chargeRuleId = data.data.chargeRuleId;
          this.form.parkingBusType = data.data.parkingBusType;
          this.form.propertyId = data.data.parentId;
          this.form.attr1 = data.data.attr1;
          this.form.pushFlag = data.data.pushFlag;
          this.form.totalNum = data.data.totalNum;
          this.form.attr8 = data.data.attr8;
          this.getCounty(this.form.city);
          
          // 在编辑模式下，创建标记点并保存引用
          const {
            createMarker,
            addMarkerToMap,
            setMapCenter,
            removeMarkerFromMap,
            reverseGeocode
          } = await import('@/utils/tianditu');
          
          // 清除之前的标记点
          if (this.currentMarker) {
            removeMarkerFromMap(this.map, this.currentMarker);
            this.currentMarker = null;
          }
          
          // 创建新标记点
          const marker = createMarker(data.data.pointLng, data.data.pointLat);
          if (marker) {
            addMarkerToMap(this.map, marker);
            this.currentMarker = marker;
          }
          
          // 设置地图中心点
          setMapCenter(this.map, data.data.pointLng, data.data.pointLat, 14);
          
          // 通过逆地理编码获取地址（必须通过 reverseGeocode 获取）
          reverseGeocode(data.data.pointLng, data.data.pointLat, (result) => {
            if (result && result.address) {
              // 解析成功，存储地址到 form.address
              this.form.address = result.address; // address -> form.address
              console.log('编辑模式：逆地理编码成功，地址:', result.address);
            } else {
              // 解析失败，使用服务器返回的地址作为备用
              console.warn('编辑模式：逆地理编码失败，使用服务器返回的地址');
              this.form.address = data.data.parkingAddress || '';
            }
          });
        });
      } else {
        this.showCounty = true;
        this.allCounty = "";
        this.form.name = "";
        this.form.city = "";
        this.form.county = "";
        this.form.address = "";

        this.form.latitude = "";
        this.form.longitude = "";
        this.form.manager = "";
        this.form.parkingBusType = "";
        this.form.pushFlag = "n";
        this.form.totalNum = 0;
        this.form.attr8 = "";
      }
    },

    addrOrEditTrue: function () {
      var _this = this;
      // console.log(this.form.name)
      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (!Boolean(_this.form.id)) {
            _this
              .$postRequest(parkAdd(), {
                parentId: _this.form.propertyId,
                // parkingId: _this.form.id,
                parkingType: _this.form.type,
                cityId: _this.form.city,
                parkingAddress: _this.form.address,  // form.address -> parkingAddress
                parkingName: _this.form.name,
                pointLat: _this.form.latitude,       // form.latitude (lat) -> pointLat
                pointLng: _this.form.longitude,      // form.longitude (lon) -> pointLng
                userId: _this.form.manager,
                attr1: _this.form.attr1,
                // chargeRuleId: _this.form.chargeRuleId,

                parkingBusType: _this.form.parkingBusType,
                pushFlag: _this.form.pushFlag,
                totalNum: _this.form.totalNum,
                attr8:_this.form.attr8,

                /*parkingBusModel:"1",
							parkingDescription:"selfSupport",
							parkingBusType: "1",
							approachNum:0,*/
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功！",
                });
                _this.search.pageNumber = 1;
                _this.initForm();
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(parkAdd() + "/" + _this.form.id, {
                parentId: _this.form.propertyId,
                parkingId: _this.form.id,
                parkingType: _this.form.type,
                cityId: _this.form.city,
                parkingAddress: _this.form.address,  // form.address -> parkingAddress
                parkingName: _this.form.name,
                pointLat: _this.form.latitude,       // form.latitude (lat) -> pointLat
                pointLng: _this.form.longitude,      // form.longitude (lon) -> pointLng
                userId: _this.form.manager,
                attr1: _this.form.attr1,
                // chargeRuleId: _this.form.chargeRuleId,
                parkingBusType: _this.form.parkingBusType,
                pushFlag: _this.form.pushFlag,
                totalNum: _this.form.totalNum,
                attr8:_this.form.attr8,
                /*parkingBusModel:"1",
							parkingDescription:"selfSupport",
							parkingBusType: "1",
							approachNum:0,*/
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功！",
                });
                _this.initForm();
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    onParkCancleBtn() {
      this.dialogFormVisible = false;
      this.initForm();
    },
    initForm() {
      this.form.id = "";
      this.form.type = "";
      this.form.city = "";
      this.form.address = "";
      this.form.name = "";
      this.form.latitude = "";
      this.form.pointLng = "";
      this.form.manager = "";
      this.form.parkingBusType = "";
      this.form.attr1 = "";
      this.form.pushFlag = "n";
      this.form.totalNum = 0;
      this.form.attr8 = "";
    },
    delPark: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该车场？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          _this.$deleteRequest(parkAddTow() + "/" + id, {}).then((data) => {
            if (data.status == 200) {
              _this.$notify({
                type: "success",
                message: "删除成功",
                title: "成功",
              });
              _this.search.pageNumber = 1;
              _this.tableList(_this.pageObj.curIndex);
            } else {
              data.status == 233;
              _this.$notify.error({
                message: "该车场下有泊位段，请先删除泊位段！",
                title: "失败",
              });
            }
          });
        }
      );
    },
    // 按时累加收费规则
    addrOrEditRuleTrue: function () {
      var _this = this;
      this.$refs["ruleForm"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisibleRule = false;
          if (_this.showPeriod) {
            if (!Boolean(_this.periodRule.chargeId)) {
              _this
                .$postRequest(addOrUpdateChargeRule(), {
                  chargeRuleId: _this.chargeRuldeMode,
                  parkingId: _this.periodRule.parkingId,
                  wdFreeTime: _this.periodRule.freeParking,
                  wdFirstQuota: _this.periodRule.ceiling,
                  wdFirstStartTime: _this.periodRule.beginTime,
                  wdFirstEndTime: _this.periodRule.end,
                  wdFirstHours: _this.periodRule.money1,
                  wdFirstPrice: _this.periodRule.money2,

                  attr1: _this.periodRule.attr1,

                  attr3: _this.periodRule.attr3,

                  attr5: _this.periodRule.periods,
                })
                .then((data) => {
                  if (data.status != 200) return _this.$layer.msg(data.message);
                  _this.$notify({
                    type: "success",
                    title: "成功",
                    message: "收费规则修改成功！",
                  });
                  _this.search.pageNumber = 1;
                  _this.tableList(_this.search.pageNumber);
                });
            } else {
              _this
                .$putRequest(
                  addOrUpdateChargeRule() + "/" + _this.periodRule.chargeId,
                  {
                    chargeRuleId: _this.chargeRuldeMode,
                    parkingId: _this.periodRule.parkingId,
                    wdFreeTime: _this.periodRule.freeParking,
                    wdFirstQuota: _this.periodRule.ceiling,
                    wdFirstStartTime: _this.periodRule.beginTime,
                    wdFirstEndTime: _this.periodRule.end,
                    wdFirstHours: _this.periodRule.money1,
                    wdFirstPrice: _this.periodRule.money2,

                    attr1: _this.periodRule.attr1,

                    attr3: _this.periodRule.attr3,

                    attr5: _this.periodRule.periods,
                  }
                )
                .then((data) => {
                  if (data.status != 200) return _this.$layer.msg(data.message);
                  _this.$notify({
                    type: "success",
                    title: "成功",
                    message: "收费规则修改成功！",
                  });
                  // _this.search.pageNumber = 1;
                  _this.tableList(_this.pageObj.curIndex);
                });
            }
          }
          if (_this.showTimeAdd) {
            if (!Boolean(_this.ruleForm.chargeId)) {
              _this
                .$postRequest(addOrUpdateChargeRule(), {
                  chargeRuleId: _this.chargeRuldeMode,
                  parkingId: _this.ruleForm.parkingId,
                  wdFreeTime: _this.ruleForm.freeParking,
                  wdFirstQuota: _this.ruleForm.ceiling,
                  wdFirstStartTime: _this.ruleForm.beginTime,
                  wdFirstEndTime: _this.ruleForm.end,
                  wdFirstHours: _this.ruleForm.money1,
                  wdFirstPrice: _this.ruleForm.money2,
                  wdFirstAfter: _this.ruleForm.money3,
                  attr1: _this.ruleForm.attr1,
                  attr2: _this.ruleForm.attr2,
                  attr3: _this.ruleForm.attr3,
                  attr4: _this.ruleForm.attr4,
                  attr5: _this.ruleForm.attr5,
                  attr6: _this.ruleForm.attr6,
                  wdFirstHoursPrice: _this.ruleForm.money4,
                  odFreeTime: _this.ruleForm.freeParkingF,
                  odFirstQuota: _this.ruleForm.ceilingF,
                  odFirstStartTime: _this.ruleForm.beginTimeF,
                  odFirstEndTime: _this.ruleForm.endF,
                  odFirstHours: _this.ruleForm.moneyF1,
                  odFirstPrice: _this.ruleForm.moneyF2,
                  odFirstAfter: _this.ruleForm.moneyF3,
                  odFirstHoursPrice: _this.ruleForm.moneyF4,
                })
                .then((data) => {
                  if (data.status != 200) return _this.$layer.msg(data.message);
                  _this.$notify({
                    type: "success",
                    title: "成功",
                    message: "收费规则修改成功！",
                  });
                  _this.search.pageNumber = 1;
                  _this.tableList(_this.search.pageNumber);
                });
            } else {
              _this
                .$putRequest(
                  addOrUpdateChargeRule() + "/" + _this.ruleForm.chargeId,
                  {
                    chargeRuleId: _this.chargeRuldeMode,
                    parkingId: _this.ruleForm.parkingId,
                    // chargeRuleId: _this.ruleForm.chargeId,
                    wdFreeTime: _this.ruleForm.freeParking,
                    wdFirstQuota: _this.ruleForm.ceiling,
                    wdFirstStartTime: _this.ruleForm.beginTime,
                    wdFirstEndTime: _this.ruleForm.end,
                    wdFirstHours: _this.ruleForm.money1,
                    wdFirstPrice: _this.ruleForm.money2,
                    wdFirstAfter: _this.ruleForm.money3,
                    attr1: _this.ruleForm.attr1,
                    attr2: _this.ruleForm.attr2,
                    attr3: _this.ruleForm.attr3,
                    attr4: _this.ruleForm.attr4,
                    attr5: _this.ruleForm.attr5,
                    attr6: _this.ruleForm.attr6,
                    wdFirstHoursPrice: _this.ruleForm.money4,
                    odFreeTime: _this.ruleForm.freeParkingF,
                    odFirstQuota: _this.ruleForm.ceilingF,
                    odFirstStartTime: _this.ruleForm.beginTimeF,
                    odFirstEndTime: _this.ruleForm.endF,
                    odFirstHours: _this.ruleForm.moneyF1,
                    odFirstPrice: _this.ruleForm.moneyF2,
                    odFirstAfter: _this.ruleForm.moneyF3,
                    odFirstHoursPrice: _this.ruleForm.moneyF4,
                  }
                )
                .then((data) => {
                  if (data.status != 200) return _this.$layer.msg(data.message);
                  _this.$notify({
                    type: "success",
                    title: "成功",
                    message: "收费规则修改成功！",
                  });
                  // _this.search.pageNumber = 1;
                  _this.tableList(_this.pageObj.curIndex);
                });
            }
          }
          if (_this.showTimeQuantum) {
            _this
              .$postRequest(addOrUpdateChargeRuleByTimeQuantum(), {
                chargeRuleId: _this.chargeRuldeMode,
                params: [
                  {
                    parkingId: _this.formRuleOne.parkingId,
                    carType: _this.formRuleOne.params[0].carType,
                    lrId: _this.formRuleOne.params[0].lrId,
                    // wdStartTime:
                    //   _this.formRuleOne.params[0].wdStartOrEndTime[0],
                    // wdEndTime: _this.formRuleOne.params[0].wdStartOrEndTime[1],
                    wdStartTime: _this.ruleForm.wdStartOrEndTime,
                    wdEndTime: _this.ruleForm.wdStartOrEndTimeEnd,
                    wdAfterHourF: _this.formRuleOne.params[0].wdAfterHourF,
                    wdFirstHour: _this.formRuleOne.params[0].wdAfterHourF,
                    wdAfterHourL: _this.formRuleOne.params[0].wdLastHour,
                    wdLastHour: _this.formRuleOne.params[0].wdLastHour,
                    wdFirstPrice: _this.formRuleOne.params[0].wdFirstPrice,
                    wdAfterPrice: _this.formRuleOne.params[0].wdAfterPrice,
                    wdLastPrice: _this.formRuleOne.params[0].wdLastPrice,
                    wdFreeMin: _this.formRuleOne.freeTime,
                    // odStartTime:
                    //   _this.formRuleOne.params[0].odStartOrEndTime[0],
                    // odEndTime: _this.formRuleOne.params[0].odStartOrEndTime[1],
                    odStartTime: _this.ruleForm.odStartOrEndTime,
                    odEndTime: _this.ruleForm.odStartOrEndTimeEnd,
                    odAfterHourF: _this.formRuleOne.params[0].odAfterHourF,
                    odFirstHour: _this.formRuleOne.params[0].odAfterHourF,
                    odAfterHourL: _this.formRuleOne.params[0].odLastHour,
                    odLastHour: _this.formRuleOne.params[0].odLastHour,
                    odFirstPrice: _this.formRuleOne.params[0].odFirstPrice,
                    odAfterPrice: _this.formRuleOne.params[0].odAfterPrice,
                    odLastPrice: _this.formRuleOne.params[0].odLastPrice,
                    odFreeMin: _this.formRuleOne.freeTime,
                  },
                ],
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "收费规则修改成功!",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          }
        }
      });
    },

    //打开收费规则窗口
    getChargeRule: function (parkingId, objCharge) {
      this.dialogFormVisibleRule = true;
      this.ruleForm.parkingId = parkingId;
      this.formRuleOne.parkingId = parkingId;

      if (objCharge) {
        var chargeRuleId = JSON.parse(objCharge).id;
        this.chargeRuldeMode = chargeRuleId;
        //按时累加
        if (chargeRuleId == "4") {
          this.ruleForm.chargeRuleId = chargeRuleId;
          this.showTimeAdd = true;
          this.showTimeQuantum = false;
          this.showPeriod = false;
          this.$postRequest(getChargeRule(), {
            parkingId: parkingId,
            // chargeRuleId: charge.id,
          }).then((data) => {
            if (data.status != 200) return;
            this.ruleForm.freeParking = data.data.wdFreeTime;
            this.ruleForm.ceiling = data.data.wdFirstQuota;
            this.ruleForm.beginTime = data.data.wdFirstStartTime;
            this.ruleForm.end = data.data.wdFirstEndTime;
            this.ruleForm.money1 = data.data.wdFirstHours;
            this.ruleForm.money2 = data.data.wdFirstPrice;
            this.ruleForm.money3 = data.data.wdFirstAfter;
            this.ruleForm.money4 = data.data.wdFirstHoursPrice;
            this.ruleForm.attr1 = data.data.attr1;
            this.ruleForm.attr2 = data.data.attr2;
            this.ruleForm.attr3 = data.data.attr3;
            this.ruleForm.attr4 = data.data.attr4;
            this.ruleForm.attr5 = data.data.attr5;
            this.ruleForm.attr6 = data.data.attr6;
            this.ruleForm.freeParkingF = data.data.odFreeTime;
            this.ruleForm.ceilingF = data.data.odFirstQuota;
            this.ruleForm.beginTimeF = data.data.odFirstStartTime;
            this.ruleForm.endF = data.data.odFirstEndTime;
            this.ruleForm.moneyF1 = data.data.odFirstHours;
            this.ruleForm.moneyF2 = data.data.odFirstPrice;
            this.ruleForm.moneyF3 = data.data.odFirstAfter;
            this.ruleForm.moneyF4 = data.data.odFirstHoursPrice;
          });
        }
        //按工作日/非工作日
        if (chargeRuleId == "1") {
          this.showTimeAdd = false;
          this.showTimeQuantum = true;
          this.showPeriod = false;
          this.formRuleOne.chargeRuleId = chargeRuleId;
          this.$get(getChargeRuleByTimeQuantum(), {
            parkingId: parkingId,
            chargeRuleId: chargeRuleId,
          }).then((data) => {
            if (data.status != 200) return;
            var result = data.data;
            for (var i = 0; i < result.length; i++) {
              if (result[i].carType == "auto") {
                this.formRuleOne.freeTime = result[i].wdFreeMin;

                for (var k in result[i]) {
                  this.formRuleOne.params[0][k] = result[i][k];
                }

                // this.formRuleOne.params[0].wdStartOrEndTime = [
                //   result[i].wdStartTime,
                //   result[i].wdEndTime
                // ];
                this.ruleForm.wdStartOrEndTime = result[i].wdStartTime;
                this.ruleForm.wdStartOrEndTimeEnd = result[i].wdEndTime;

                // this.formRuleOne.params[0].odStartOrEndTime = [
                //   result[i].odStartTime,
                //   result[i].odEndTime
                // ];
                this.ruleForm.odStartOrEndTime = result[i].odStartTime;
                this.ruleForm.odStartOrEndTimeEnd = result[i].odEndTime;
              }
            }
          });
        }

        if (chargeRuleId == 2) {
          this.periodRule.chargeRuleId = chargeRuleId;
          this.periodRule.parkingId = parkingId;
          this.showPeriod = true;
          this.showTimeAdd = false;
          this.showTimeQuantum = false;
          this.$postRequest(getChargeRule(), {
            parkingId: parkingId,
            // chargeRuleId: charge.id,
          }).then((data) => {
            if (data.status != 200) return;

            this.periodRule.freeParking = data.data.wdFreeTime;
            this.periodRule.ceiling = data.data.wdFirstQuota;
            this.periodRule.beginTime = data.data.wdFirstStartTime;
            this.periodRule.end = data.data.wdFirstEndTime;
            this.periodRule.money1 = data.data.wdFirstHours;
            this.periodRule.money2 = data.data.wdFirstPrice;
            this.periodRule.attr1 = data.data.attr1;
            this.periodRule.attr3 = data.data.attr3;
            this.periodRule.periods = data.data.attr5;
          });
        }
      } else {
      }
    },
    openDialogRule: function () {
      this.getAllChargeRuleType();
    },

    closeDialogParking: function () {
      this.$refs["form"].resetFields();
    },

    closeDialogRule: function () {
      this.chargeRuldeMode = "4";
      //按时累计
      this.ruleForm.chargeRuleId = "";
      this.ruleForm.parkingId = "";
      this.ruleForm.freeParking = "";
      this.ruleForm.ceiling = "";
      this.ruleForm.beginTime = "";
      this.ruleForm.end = "";
      this.ruleForm.money1 = "";
      this.ruleForm.money2 = "";
      this.ruleForm.money3 = "";
      this.ruleForm.money4 = "";
      this.ruleForm.freeParkingF = "";
      this.ruleForm.ceilingF = "";
      this.ruleForm.beginTimeF = "";
      this.ruleForm.endF = "";
      this.ruleForm.moneyF1 = "";
      this.ruleForm.moneyF2 = "";
      this.ruleForm.moneyF3 = "";
      this.ruleForm.moneyF4 = "";
      this.ruleForm.attr1 = "";
      this.ruleForm.attr2 = "";
      this.ruleForm.attr3 = "";
      this.ruleForm.attr4 = "";
      this.ruleForm.attr5 = "";
      this.ruleForm.attr6 = "";
      //按时间段
      this.formRuleOne = {
        chargeRuleId: "",
        parkingId: "",
        freeTime: "",
        params: [
          {
            lrId: "",
            carType: "auto",
            wdStartOrEndTime: ["", ""],
            wdAfterHourF: "",
            wdLastHour: "",
            wdFirstPrice: "",
            wdAfterPrice: "",
            wdLastPrice: "",
            wdFreeMin: "",
            odStartOrEndTime: ["", ""],
            odAfterHourF: "",
            odLastHour: "",

            odFirstPrice: "",
            odAfterPrice: "",
            odLastPrice: "",
            odFreeMin: "",
          },
        ],
      };
    },

    showName(v) {
      // console.log(v)
    },
    parkingTypeList() {
      this.$get(getParkingType()).then((data) => {});
    },
    generateActivationCode(id) {
      this.activationCodeDialogVisible = true;
      this.activationCodeForm.parkingId = id;
    },
    generateActivationCodeTrue() {
      this.activationCodeDialogVisible = false;
      this.$postRequest(getGenerateActivationCode(), {
        parkingId: this.activationCodeForm.parkingId,
        udId: this.activationCodeForm.udId,
        type: this.activationCodeForm.type,
        begindate: this.activationCodeForm.begindate,
        enddate: this.activationCodeForm.enddate,
      }).then((data) => {
        if (data.status != 200) return this.$layer.msg(data.message);
        this.$notify({
          type: "success",
          title: "成功",
          message: "激活码生成成功！",
        });
        this.viewActivationCodeDialogVisible = true;
      });
    },
    viewActivationCodeList() {
      this.$get(getActivationCodeList(), {
        parkingId: this.activationCodeForm.parkingId,
        limit: 0,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.activationCodeData = data.data.rows;
      });
    },
    viewActivationCode(id) {
      this.activationCodeForm.parkingId = id;
      this.viewActivationCodeDialogVisible = true;
    },
    codeDownload(id, name) {
      this.codeDownloadData.chargeUserId = "";
      this.getAllChargeUsers();
      this.outerCodeDialogVisible = true;
      // this.codeDialogVisible=true;
      this.codeDownloadData.parkingId = id;
      this.codeDownloadData.parkingName = name;
    },
    qrcode(id, chargeUserId, w, h) {
      let qrcode = new QRCode("qrcode", {
        width: w,
        height: h,
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear(); //清除二维码
      // qrcode.makeCode(`http://bosk88.natapp1.cc/pay/sweepCodePayment/onSite?parkingId=${id}`)
      qrcode.makeCode(
        `${this.$codeUrl}/pay/sweepCodePayment/onSite?parkingId=${id}&chargeId=${chargeUserId}`
      ); //生成另一个新的二维码
      // qrcode.makeCode(`http://wo100.natapp1.cc/pay/sweepCodePayment/onSite?parkingId=${id}`) //生成另一个新的二维码
    },
    downloadQrcode(w, h) {
      document.getElementById("qrcode").innerHTML = "";
      var id = this.codeDownloadData.parkingId;
      var name = this.codeDownloadData.parkingName;
      var chargeUser = this.codeDownloadData.chargeUserId;
      this.qrcode(id, chargeUser, w, h);
      setTimeout(function () {
        var qrcode = document.getElementById("qrcode");
        var img = qrcode.getElementsByTagName("img")[0];
        var link = document.createElement("a");
        var url = img.getAttribute("src");
        link.setAttribute("href", url);
        link.setAttribute("download", `${name}(${w}).png`);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
      }, 1);
    },
    payType() {
      this.$get(getAllPayType()).then((data) => {
        this.allPayTypeData = data.data.rows;
      });
    },
    payBind(id, paymentChannel) {
      this.payTypeDialogVisible = true;
      this.payTypeForm.payType = paymentChannel;
      this.payTypeForm.parkingId = id;
    },
    payBindTrue() {
      this.payTypeDialogVisible = false;
      this.$putRequest(addOrEdit() + "/" + this.payTypeForm.parkingId, {
        parkingId: this.payTypeForm.parkingId,
        paymentChannel: this.payTypeForm.payType,
      }).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          type: "success",
          title: "成功",
          message: "支付绑定成功！",
        });
        this.tableList(this.pageObj.curIndex); //
      });
    },
    getActivationCodeType(value) {
      if (value == 1) {
        this.dateView = false;
      } else {
        this.dateView = true;
      }
    },
    hasPayConfigure(paymentChannel) {
      this.$get(getPayConfigure(), {
        parkingId: this.payTypeForm.parkingId,
        paymentChannel: paymentChannel,
      }).then((data) => {
        if (data.status == 400) {
          this.$message({
            message: data.message,
            type: "warning",
          });
        }
      });
    },
    getAllChargeUsers: function () {
      var _this = this;
      this.$get(chargeUserList() + "?isDeleted=0", {
        limit: 0,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        _this.allChargeUserData = data.data.rows;
        // _this.tableListData=data.data;
      });
    },
    selectedChargerUser() {
      this.outerCodeDialogVisible = false;
      this.codeDialogVisible = true;
    },
    getAllChargeRuleType() {
      this.$get(requestAllChargeRuleType()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.allChargeRuleTypeData = data.data.rows;
      });
    },
    getChargeRuleMode(v) {
      if (v == "4") {
        this.showTimeAdd = true;
        this.showTimeQuantum = false;
        this.showPeriod = false;
      }
      if (v == "1") {
        this.showTimeAdd = false;
        this.showTimeQuantum = true;
        this.showPeriod = false;
      }
      if (v == "2") {
        this.showTimeAdd = false;
        this.showTimeQuantum = false;
        this.showPeriod = true;
      }
    },
    startInvoice(parkingId) {
      //console.log(event.target.checked)
    },
    getBaseConfigure() {
      this.$get(requestParkingBaseConfig()).then((data) => {
        if (data.status != 200) return;
        this.baseConfigureData = data.data.rows;
      });
    },
    openConfigureDialog() {},
    closeConfigureDialog() {
      this.configureForm.parkingId = "";
      this.configureForm.code = [];
    },
    configure(id) {
      this.configureForm.parkingId = id;
      this.oneConfigure(id);
      this.dialogConfigureVisible = true;
    },
    clickItemConfigure(item, dd) {
      let data = [];
      if (dd == "open") {
        data = this.configureData.map(function (val, index, array) {
          if (item.value == val.value) {
            val.isOpen = true;
            val.isClose = false;
          }
          return val;
        });
        this.configureForm.code.push(item.value);
      }
      if (dd == "close") {
        data = this.configureData.map(function (val, index, array) {
          if (item.value == val.value) {
            val.isOpen = false;
            val.isClose = true;
          }
          return val;
        });
      }
      this.configureData = data;
    },
    oneConfigure(id) {
      var _this = this;
      this.$get(getOneParkingConfigure(), {
        parkingId: id,
      }).then((data) => {
        if (data.status != 200) return;
        let dd = data.data;
        let dds = this.baseConfigureData;
        if (dd.length > 0) {
          this.configureData = dds.map(function (val, index, array) {
            let itemFind = dd.find((item) => val.value === item.configValue);
            if (itemFind) {
              val.isOpen = true;
              val.isClose = false;
            } else {
              val.isOpen = false;
              val.isClose = true;
            }
            return val;
          });
        } else {
          this.configureData = dds.map(function (val, index, array) {
            val.isOpen = false;
            val.isClose = true;
            return val;
          });
        }
      });
    },
    configureOneConfigure() {
      this.dialogConfigureVisible = false;
      let codes = [];
      for (let item of this.configureData) {
        if (item.isOpen) {
          codes.push(item.value);
        }
      }
      this.$postRequest(requestConfigureOneParkingConfigure(), {
        parkingId: this.configureForm.parkingId,
        values: codes,
      }).then((data) => {
        if (data.status != 200) {
          this.$notify.error({
            type: "success",
            message: data.message,
            title: "失败",
          });
          return;
        }
        this.$notify({
          type: "success",
          message: "配置成功！",
          title: "成功",
        });
      });
    },
    chargeLower() {
      alert("下发成功");
    },
    onRuleAddClick() {
      this.periodRule = {
        ...this.periodRule,
        periods: [
          ...this.periodRule.periods,
          {
            id: Math.random().toString(16).slice(2),
            exceed: "",
            every: "",
            car: "",
            cart: "",
            superCar: "",
          },
        ],
      };
    },
    onRuleReduceClick(id) {
      if (this.periodRule.periods.length <= 1) return;
      const periods = this.periodRule.periods.filter(
        (period) => period.id !== id
      );
      this.periodRule = {
        ...this.periodRule,
        periods: [...periods],
      };
    },
    async onAddressToLatlng() {
      if (!this.form.address) return;
      
      // 导入天地图工具类
      const {
        geocodeAddress,
        createMarker,
        addMarkerToMap,
        updateMarkerPosition,
        setMapCenter
      } = await import('@/utils/tianditu');
      
      // 地理编码：根据地址获取坐标
      geocodeAddress(this.form.address, (result) => {
        console.log('地址转坐标结果:', result);
        if (result && result.lng && result.lat) {
          const lng = result.lng;
          const lat = result.lat;
          
          console.log('地址解析成功 - 经度:', lng, '纬度:', lat);
          
          // 先存储经纬度到form
          // form.longitude 对应 lon（经度）
          // form.latitude 对应 lat（纬度）
          this.form.longitude = lng; // lon -> form.longitude
          this.form.latitude = lat;  // lat -> form.latitude
          
          // 如果已有标记点，更新位置；否则创建新标记点
          if (this.currentMarker) {
            console.log('更新现有marker位置');
            const updated = updateMarkerPosition(this.currentMarker, lng, lat);
            if (!updated) {
              console.warn('更新marker位置失败，尝试重新创建');
              // 如果更新失败，移除旧marker，创建新的
              // 动态导入removeMarkerFromMap
              import('@/utils/tianditu').then((tiandituUtils) => {
                if (tiandituUtils && tiandituUtils.removeMarkerFromMap) {
                  tiandituUtils.removeMarkerFromMap(this.map, this.currentMarker);
                  this.currentMarker = null;
                }
              }).catch(() => {
                console.warn('导入removeMarkerFromMap失败');
              });
            }
          }
          
          // 如果没有marker或更新失败，创建新marker
          if (!this.currentMarker) {
            console.log('创建新marker');
            const marker = createMarker(lng, lat);
            if (marker) {
              const added = addMarkerToMap(this.map, marker);
              if (added) {
                this.currentMarker = marker;
                console.log('Marker已添加到地图');
              } else {
                console.error('Marker添加失败');
                this.$message.warning('标记点添加失败，请检查地图是否已加载');
              }
            } else {
              console.error('创建Marker失败');
              this.$message.warning('创建标记点失败');
            }
          }
          
          // 设置地图中心点
          setMapCenter(this.map, lng, lat, 18);
          
          // 地址已经存在form.address中，不需要更新
        } else {
          console.error('无法获取坐标信息', result);
          this.$message.warning('无法解析地址坐标，请检查地址是否正确');
        }
      });
    },
  },
  computed: {
    ...mapGetters(["elements"]),
    ...mapState({ proprety: (state) => state.parking.property }),
    permiss() {
      this.parklist_btn_add = this.elements["parklist:btn_add"];
      this.parklist_btn_rule = this.elements["parklist:btn_rule"];
      this.parklist_btn_pkset = this.elements["parklist:btn_pkset"];
      this.parklist_btn_control = this.elements["parklist:btn_control"];
      this.parklist_btn_person = this.elements["parklist:btn_person"];
      this.parkset_btn_edit = this.elements["parklist:btn_edit"];
      this.parklist_btn_remove = this.elements["parklist:btn_remove"];
      //console.log("parklist_btn_remove")
      //console.log(this.parklist_btn_remove)
    },
  },
  components: {
    Page,

    Refresh,
    AllTree,
  },

  created: function () {
    this.permiss;
    this.getParkingBusType();
    this.getParkType();
    this.getCity();
    this.getRulesType();
    this.payType();
  },
  mounted: function () {
    this.getBaseConfigure();
    this.getAllProperty();
    this.tableList();
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },
  },
};
</script>

<style scoped>
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}

.searchbox {
  background: #f9f9fb;
  /* height:65px; */
  border-bottom: 10px solid #eff2f7;
}
.table thead {
  background: #f9f9fb;
}
.list {
  width: 100% !important;
  position: relative;
}
.pagbox {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
/* .el-form-item{
  margin-bottom: 14px;
} */
.size {
  color: red;
  border-bottom: #ddd solid 1px;
  margin-bottom: 3px;

  font-weight: bold;
}
#qrcode {
  display: none;
}
.columns {
  display: flex;
  justify-content: flex-start;
}
.column-last {
  justify-content: center;
}
.position {
  margin-left: 92px;
  margin-top: -17px;
}
.gap {
  height: 1px;
  width: 100%;
  background: #ddd;
  margin-bottom: 20px;
}
.discount {
  display: flex;
  justify-content: baseline;
  align-items: center;
}
.car-discount {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 50px;
}
.car-discount .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.discount-tip {
  margin-left: 10px;
}
</style>
<style>
.parklist .chargerule-mode .el-form-item__label {
  text-align: left !important;
  color: red;
  font-weight: bold;
  width: 80px !important;
}
.column-last .el-form-item:first-child {
  display: flex;
  justify-content: center;
}
.column-last .el-form-item:first-child .el-form-item__content {
  margin-left: 0 !important;
}
.parklist .chargerule-mode .el-form-item__content {
  margin-left: 80px !important;
}
.parklist .chargerule-mode .el-input {
  border: 1px solid red;
  border-radius: 5px;
}
.parklist .chargerule-mode .el-select .el-input.is-focus .el-input__inner {
  border: none !important;
}
.parklist .chargerule-mode .el-select .el-input__inner:focus {
  border: none !important;
}
.parklist .chargerule-mode .el-input__inner {
  border: none !important;
}
.parklist .chargerule-mode .el-icon-arrow-up:before {
  color: red;
}
.parklist .columns .el-input {
  width: 80px;
}
.parklist .el-input__inner {
  border-radius: 5px !important;
}
.parklist .el-dialog__body {
  display: flex !important;
  justify-content: flex-start !important;
}
/* .parklist .columns .el-form-item:first-child {
  width: 55%;
} */
/* .parklist .columns .el-form-item:last-child {
  width: 45%;
} */
.parklist .columns-others .el-form-item {
  width: 100% !important;
}
.parklist .period-group {
  border: 1px dashed #ddd;
  border-radius: 20px;
  padding: 20px;
  box-sizing: border-box;
}
.add .el-icon-circle-plus-outline {
  color: #409eff;
  font-size: 50px;
}
.add {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}
</style>
<style>
.limit .el-form-item__label {
  width: 90px !important;
}
.limit .el-form-item__content {
  margin-left: 90px !important;
}
.limit .limit-tip .el-form-item__label {
  width: 130px !important;
}
.dialog-park-form .el-select {
  display: block;
}
.parklist .el-input-group {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.parklist .el-input-group .el-input__inner {
  width: 90%;
  height: 100%;
}
.parklist .el-input-group .el-input-group__append {
  height: 100%;
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.parklist .el-input-group .el-input-group__append .el-icon-search {
  font-size: 20px;
}


/* 暂时移除隐藏天地图图标的样式，确保地图能正常显示 */
/* 隐藏天地图版权信息和图标 - 只隐藏版权相关元素，不影响地图显示 */
/* #areaMap .anchorBL,
#areaMap .TDMap_cpyCtrl,
#areaMap .anchorTR,
#areaMap .anchorTL,
#areaMap .anchorBR {
  display: none !important;
} */

/* 隐藏天地图版权链接和图片 */
/* #areaMap a[href*="tianditu.gov.cn"]:not([class*="map"]),
#areaMap img[src*="tianditu.gov.cn"]:not([class*="map"]),
#areaMap img[alt*="天地图"],
#areaMap img[alt*="国家基础地理信息中心"] {
  display: none !important;
} */
</style>
